/*
 * This code is the intellectual property of Bulb Inc. and other software publishers;
 * it may not be altered, copied or disclosed without prior written approval.
 * Copyright 2016-2017, Bulb Inc.  For more information, please email contact@hellobulb.com.
 */

angular.module('bulbApp.adminModule')
  .controller('OrgModalController', ['account', 'organizations', '$modalInstance', 'Restangular', 'BulbModalService', OrgModalController]);

function OrgModalController(account, organizations, $modalInstance, Restangular, BulbModalService) {
  const that = this;
  this.account = account;
  this.allOrganizations = organizations;

  this.addOrganization = function (organization) {
    that.account.patch({ addedOrganization: organization.id }).then((savedAccount) => {
      $modalInstance.close(savedAccount);
    });
  };

  this.removeOrganization = function (membership) {
    const modalOptions = {
      titleCode: 'organization_bulb_school_direct_toggle_warning_title',
      bodyCode: 'organization_modal_remove_warning',
      showOkButton: true,
      showCancelButton: true,
      fontAwesomeCode: 'fas fa-exclamation-triangle',
      windowClass: 'updated-modal-design',
    };

    BulbModalService.show(modalOptions).then(() => {
      that.account.patch({ removedOrganization: membership.groupId }).then((savedAccount) => {
        $modalInstance.close(savedAccount);
      });
    });
  };

  this.addAdmin = function (membership) {
    Restangular.one('organizations', membership.groupId).patch({ adminToAdd: that.account.id }).then(() => {
      $modalInstance.close(that.account);

      // Rather than refetching the account to get the updated organization record, go ahead and manually
      // update the organization here.
      const fullOrganization = that.findOrganization(membership.groupId);
      fullOrganization.administratorIds.push(`Account:${account.id}`);

      // Also update the account groupMembership entry to indicate it is an admin:
      membership.isAdmin = true;
    });
  };

  this.removeAdmin = function (membership) {
    Restangular.one('organizations', membership.groupId).patch({ adminToRemove: that.account.id }).then(() => {
      $modalInstance.close(that.account);

      // Rather than refetching the account to get the updated organization record, go ahead and manually remove
      // the admin id here.
      const organization = that.findOrganization(membership.groupId);
      const index = organization.administratorIds.indexOf(`Account:${account.id}`);
      organization.administratorIds.splice(index, 1);

      // Also update the account organization entry to indicate it is an admin here:
      membership.isAdmin = false;
    });
  };

  this.findOrganization = function (id) {
    return that.allOrganizations.find((orgObj) => orgObj.id === id);
  };
}
